import FetcherFactory from 'Shared/FetcherFactory'
import { getAuthenticityToken } from 'Shared/helpers'

import queryString from 'query-string'

export const reducerName = 'CLONE_LEAGUES_SESSIONS'

const factory = new FetcherFactory(
  reducerName,
  ({params, state, dispatch, factory}) => {
    const serializedParams = queryString.stringify(params)
    const serializedQueryString = new URLSearchParams(serializedParams).toString()

    return fetch(`${state.baseURL}?${serializedQueryString}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': getAuthenticityToken(),
        'Content-Type': 'application/json',
      },
    }).then(response => {
      // Pre-process the response
      return response.json().then(data => {

        const setPaginationAction = factory.getSetPaginationAction()
        dispatch(setPaginationAction(data?.pagination))

        return ({
          data: data,
          status: response.status,
        })
      })
    })
  },
  {
    ignoreParamsCaching: true,
  },
)

const CloneLeaguesSessionsReducer = factory.getReducer()
export const namedReducer = {[reducerName]: CloneLeaguesSessionsReducer}

export const getInitialState = ({
  cloneLeaguesSessions,
  pagination,
  searchCloneLeaguesSessionsURL,
  newCloneLeaguesSessionURL,
  pollSessionsStatusesURL,
  editCloneLeaguesSessionURL,
  customerDateFormat,
}) => {
  return {
    data: {
      cloneLeaguesSessions: cloneLeaguesSessions,
    },
    pagination: pagination,
    baseURL: searchCloneLeaguesSessionsURL,
    newCloneLeaguesSessionURL: newCloneLeaguesSessionURL,
    pollSessionsStatusesURL: pollSessionsStatusesURL,
    editCloneLeaguesSessionURL: editCloneLeaguesSessionURL,
    customerDateFormat: customerDateFormat,
  }
}

export const selectEditURLForSession = (sessionID) => (state) => {
  const editCloneLeaguesSessionURL = state[factory.name]?.editCloneLeaguesSessionURL
  return editCloneLeaguesSessionURL.replace(':session_id', sessionID)
}

export const selectCustomerDateFormat = state => state[factory.name]?.customerDateFormat
export const selectNewCloneLeaguesSessionURL = state => state[factory.name]?.newCloneLeaguesSessionURL
export const selectCloneLeaguesSessions = state => state[factory.name]?.data?.cloneLeaguesSessions || []
export const selectPollSessionsStatusesURL = state => state[factory.name]?.pollSessionsStatusesURL
export const selectCloneLeaguesSessionByID = sessionID => state => state[factory.name]?.data?.cloneLeaguesSessions?.find(session => session.id === sessionID)

export const setPageCloneLeaguesSessions = factory.getSetPageAction()

export const selectCloneLeaguesSessionsPagination = state => state[factory.name]?.pagination
export const fetchCloneLeaguesSessionsMergedParams = factory.getFetchAction({useMergedParams: true})
export const setCloneLeaguesSessionsData = factory.getSetDataAction()
